export default "__VITE_ASSET__Dqn0dlsT__"